import { PlaybookSectionDetail } from '@src/components/sco/Education/PlaybookSectionDetail';
import { EducationPage } from '@src/templates/EducationPage';
import { useParams } from 'next/navigation';
import React from 'react';
export { getServerSideProps } from '@src/lib/server-side-rendering';
export default EducationPage(function Page(props) {
  const params = useParams();
  return <PlaybookSectionDetail playbookSectionSlug={`${params.playbookSectionSlug}`} playbookSlug={`${params.playbookSlug}`} />;
});